var FocusTrapStyle = {};

export { FocusTrapStyle as default };
